import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import BannerLanding from '../components/BannerLanding'

const Portfolio = (props) => (
    <Layout>
        <Helmet>
            <title>resume</title>
            <meta name="description" content="Portfolio Page" />
        </Helmet>

        <BannerLanding />

        <div id="main">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h2>概要</h2>
                    </header>
                    <p>WORDPRESSフルカスタマイズの経験が豊富で、現場では社員へのヒアリング、要件定義から実装まで一連の作業を担当いたしております。サーバー構築も含めたバックエンド開発とフロントエンド開発の両方を一人称で対応しています。 メディアサイトの開発実績が多いため、SEO施策（主に内部対策）の知見があり、GOOGLE PAGESPEED INSIGHTSではモバイル・PC共に99点を取得した実績もございます。</p>
                    <header className="major">
                        <h2>スキル</h2>
                    </header>
                    <h3>言語</h3>
                    <p>XHTML | HTML5 | css3 | scss | JavaScript | PHP | TypeScript | JAVA(thymeleaf)</p>
                    <h3>フレームワーク等</h3>
                    <p>WordPress | jQuery | Vue.js | Nuxt.js | react.js | CakePHP | SpringBoot(thymeleaf)</p>
                    <h3>AWS</h3>
                    <p>AWS | ELB | EC2 | RDB | S3</p>
                    <h3>RDB/NoSQL</h3>
                    <p>MySQL | PostgreSQL | Oracle | SQL Server</p>
                    <h3>ツール/サービス</h3>
                    <p>GitHub | GitLab | Confluence | JIRA | VirtualBox | Vagrant | webpack | VScode | intelliJ | Zeplin</p>
                    <header className="major">
                        <h2>主な業務経歴</h2>
                    </header>
                    <h3>法務系システムの開発・業務改善(2019〜)</h3>
                    <ul>
                        <li>フロントエンドのルール策定・モダン開発環境の構築</li>
                        <li>旧コードのリファクタリング</li>
                        <li>コーディング（フロントエンド）</li>
                    </ul>
                    <h3>金融系LPの設計・開発・保守(2018〜2019)</h3>
                    <ul>
                        <li>設計、要件定義</li>
                        <li>コーディング（フロントエンド、バックエンド）</li>
                    </ul>
                    <h3>エンタメ系オウンドメディアの企画・設計・開発・保守(2017〜2018)</h3>
                    <ul>
                        <li>企画、設計、要件定義</li>
                        <li>サーバー設定</li>
                        <li>コーディング（フロントエンド、バックエンド）</li>
                    </ul>
                    <h3>医療系オウンドメディアの設計・開発・保守(2016〜2017)</h3>
                    <ul>
                        <li>チーム（開発）リーダー</li>
                        <li>設計、要件定義</li>
                        <li>サーバー設定</li>
                        <li>コーディング（フロントエンド、バックエンド）</li>
                    </ul>
                    <h3>個人事業主として独立(2016〜)</h3>
                    <h3>福祉系WEBシステムの企画・設計・開発・保守(2010〜2015)</h3>
                    <ul>
                        <li>ディレクション</li>
                        <li>企画、設計、要件定義</li>
                        <li>デザイン、ライティング</li>
                        <li>コーディング（フロントエンド）</li>
                    </ul>
                    <h3>大手証券会社にてリテール営業(2006〜2009)</h3>
                </div>
            </section>
        </div>

    </Layout>
)

export default Portfolio